// extracted by mini-css-extract-plugin
export default {"heading":"BasicInformation_heading__0ozzG","wrapper":"BasicInformation_wrapper__A9FxX"};